/* eslint-disable no-use-before-define */
import React from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'

interface IConfirmationDialogProps {
  open: boolean,
  handleYes: () => void,
  handleNo: () => void
}

const ConfirmationDialog: React.FC<IConfirmationDialogProps> = ({ open, handleYes, handleNo }) => {
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleNo}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          Confirmation
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure want to update this trophy points?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleNo} color="primary">
            No
          </Button>
          <Button onClick={handleYes} variant="contained" color="primary" autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default ConfirmationDialog